import { render, staticRenderFns } from "./resetpsd.vue?vue&type=template&id=fc6d67c4&scoped=true"
import script from "./resetpsd.vue?vue&type=script&lang=js"
export * from "./resetpsd.vue?vue&type=script&lang=js"
import style0 from "./resetpsd.vue?vue&type=style&index=0&id=fc6d67c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6d67c4",
  null
  
)

export default component.exports